<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-8 align-self-center">
            <h2 class="mb-0">{{ $t("navigations.rbqm dashboard") }}</h2>
        </div>
        <div class="d-flex align-items-center col-md-2">
            <label for="selectSite" class="w-100">Select Site</label>
            <select id="selectSite" v-model="selectedSite" @change="getScoreInfos()">
                <option selected value="">{{$t('navigations.all')}}</option>
                <option
                    v-for="site in sites"
                    :key="site.siteID"
                    :value="site.siteID"
                >
                    {{ site.siteCode }}
                </option>
            </select>
        </div>
    </div>
    <div class="wrapper wrapper-content">
        <!-- Cards -->
        <div class="row mb-2">
            <div class="col-md-3 px-1">
                <div class="card h-100 border-bottom border-2 border-primary">
                    <div class="card-body pl-1">
                        <div class="d-flex align-items-center" @click="viewRiskPopup('studyRisk')">
                            <div class="bg-danger bg-opacity-10 p-3 rounded-two me-3">
                                <i class="fa fa-users text-white fs-4"></i>
                            </div>
                            <div class="card-body" style="cursor: pointer;">
                                <h5 class="card-title">
                                    {{ $t("navigations.high risks") }}
                                </h5>
                                <p v-if="this.studyRisk.totalCount" class="card-text fs-4 mb-0">
                                  {{ this.studyRisk.totalCount }}
                                </p>
                                <p v-else class="card-text fs-4 mb-0">0</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 px-1">
                <div class="card h-100 border-bottom border-2 border-primary" @click="viewRiskPopup('siteRisk')">
                    <div class="card-body pl-1">
                        <div class="d-flex align-items-center">
                            <div class="bg-primary bg-opacity-10 p-3 rounded-two me-3">
                                <i class="fa fa-users text-white fs-4"></i>
                            </div>
                            <div class="card-body" style="cursor: pointer;">
                                <h5 class="card-title">
                                    {{ $t("navigations.high risk sites") }}
                                </h5>
                                <p v-if="this.siteRisk.totalCount" class="card-text fs-4 mb-0">
                                  {{ this.siteRisk.totalCount }}
                                </p>
                                <p v-else class="card-text fs-4 mb-0">0</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 px-1">
                <div class="card h-100 border-bottom border-2 border-primary">
                    <div class="card-body pl-1">
                        <div class="d-flex align-items-center">
                            <div class="bg-primary bg-opacity-10 p-3 rounded-two me-3">
                                <i class="fa fa-users text-white fs-4"></i>
                            </div>
                            <div class="card-body" style="cursor: pointer;">
                                <h5 class="card-title">
                                    {{ $t("navigations.high risks") }}
                                </h5>
                                <p class="card-text fs-4 mb-0">0</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 px-1">
                <div class="card h-100 border-bottom border-2 border-primary">
                    <div class="card-body pl-1">
                        <div class="d-flex align-items-center">
                            <div class="bg-primary bg-opacity-10 p-3 rounded-two me-3">
                                <i class="fa fa-users text-white fs-4"></i>
                            </div>
                            <div class="card-body" style="cursor: pointer;">
                                <h5 class="card-title">
                                    {{ $t("navigations.high risks") }}
                                </h5>
                                <p class="card-text fs-4 mb-0">0</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of cards -->
        <!-- Graphs -->
         <div class="row">
            <div class="col-md-12 pl-1 mb-2">
          <historytab
            :historyarray="historykeys"
            @gotohistorylevel="gotohistorylevel"
            @exporttopdf="exporttopdf"
            @exporttoexcell="exporttoexcell"
          />
        </div>
            <div class="col-md-6 mb-2  pl-1">
                <grouplinechart
                    :loader="loader"
                    :data="data"
                    :templateId="templateId"
                    :xAxisValue="grouplinechartkeys['xaxiskey']"
                    :optionstochose="grouplinechartkeys['searchkey']"
                    yAxisValue=""
                    :groupCategoryValue="grouplinechartkeys['groupkey']"
                    yaxislabel="Number of outcomes"
                    xaxislabel="Created date"
                    :fromPage="'labSummary'"
                    :requiredOptions="false"
                    chartLabel="Risk Outcome Trends Over Time"
                    :custcolors="lineColors"
                    :colorcodes="colorcodes"
                    @drilldowncurrentchart="drilldowncurrentchartforbar"
                    @opendrillpopup="drillpopupopened"
                    @setgroupkeys="retaingroupchartvars"
                    :showAllQueries="true"
                    allQueriesLabel="Total Outcomes"
                    :showdopdownoptions="false"
                    @exporttoexcell="exporttoexcell"
                />
            </div>
            <div class="col-md-6 mb-2  pl-1">
                <groupbarchart
                    :loader="loader"
                    :data="data"
                    :templateId="templateId"
                    :xAxisValue="groupchartkeys['xaxiskey']"
                    yAxisValue=""
                    yAxisLabel="Number of risks"
                    xAxisLabel="category"
                    :groupCategoryValue="groupchartkeys['groupkey']"
                    :fromPage="'labSummary'"
                    :requiredOptions="false"
                    chartLabel="Cross-Category Comparisons"
                    :custcolors="customcolors"
                    :colorcodes="colorcodes"
                    @drilldowncurrentchart="drilldowncurrentchartforbar"
                    @opendrillpopup="drillpopupopened"
                    @setgroupkeys="retaingroupchartvars"
                    @exporttoexcell="exporttoexcell"
                />
            </div>
            <div class="col-lg-12">
                <div class="stat-card-white ">
                    <div class="stat-header-white">
                        <span>Risk Outcome Distribution</span>
                    </div>
                    <div class="stat-body-white">
                        <advtable 
                            fileheadding="Risk summary"
                            :loader="loader"
                            :data="data"
                            fromPage="patientRetention"
                            @drilldowncurrentchart="drilldowncurrentchartforbar"/>
                    </div>
                </div>
            </div>
         </div>
        <!-- End of graphs -->
    </div>

    <RiskListPopup
        v-if="showRiskListPopup"
        :title="riskListTitle"
        :data="riskListData"
        @closepopup="showRiskListPopup = false"
    />
</template>
<script src="./RiskSummary.js"></script>
<style scoped>
.card {
  border: none;
  border-radius: 0px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
}

.card:hover {
  transform: translateY(-5px);
}
.rounded-two {
  border-radius: 0rem 2.25rem 2.25rem 0rem !important;
}

</style>